import React from 'react'
import { Route, Routes } from 'react-router'

import { AiUsageExportPage } from '../pages/AiUsageExportPage'
import { ApplicationAdminTopPage } from '../pages/ApplicationAdminTopPage'
import { BrandAccountsListPage } from '../pages/BrandAccountsListPage'
import { CoreMembersListPage } from '../pages/CoreMembersListPage'
import { UsersDownloadPage } from '../pages/UsersDownloadPage'

import { type PathKey, pathKeys, resolve } from './paths'

export const pathPageMap: Record<PathKey, React.ComponentType> = {
  top: ApplicationAdminTopPage,
  brandAccountsList: BrandAccountsListPage,
  coreMembersList: CoreMembersListPage,
  usersDownload: UsersDownloadPage,
  aiUsageExport: AiUsageExportPage,
}

export const Root = () => (
  <Routes>
    {pathKeys.map((pathKey) => {
      const Page = pathPageMap[pathKey]

      return <Route key={pathKey} element={<Page />} path={resolve(pathKey)} />
    })}
  </Routes>
)
